import { useState ,useEffect} from 'react';
import './ContactForm.css';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import { useScreenSize } from './screenSize'; // עדכן נתיב לפי הצורך
function ContactForm({ offerData ,setIsFormSent ,setisConnectionProblem}) {
const [name, setName] = useState('');
const [phone, setPhone] = useState('');
const [option, setOption] = useState('');
const [acceptsMarketing  , setAcceptsMarketing ] = useState(false);
const [acceptedTerms  , setAcceptedTerms ] = useState(false);
 
const [freeText, setFreeText] = useState('');
const textAreaMaxlength = 250;
const [errorMessage, setErrorMessage] = useState('');
const [shake, setShake] = useState(false);


  const { screenWidth, deviceType } = useScreenSize();


// https://www.kerk.co.il/landing-pages/logo-01/?source=sourcetest1&campaign=mycampaigntest1
  useEffect(() => {
  }, [screenWidth, deviceType]);

  const [searchParams] = useSearchParams();
  const source  = searchParams.get("source");
  const campaign  = searchParams.get("campaign");


  const landingPageid     = "Kerk-LPID-main-332kf56fs34au86al"  /// עמוד ראשי במקום אתר

   const clientId      = "Kerk-CID-s3045xs34a6136u86al"  // של אלון
  
  useEffect(() => {setErrorMessage("") }, [name,phone,freeText]);

 

  const makeClick = async () => {
   if (!name) { setErrorMessage('אנא מלאו שם'); return;}
   if (!phone) {setErrorMessage('אנא מלאו מספר טלפון');return; }

    try {
      // console.log("start action");
        const url = `${process.env.REACT_APP_API_PREFIX}/leads/new`;
  //  console.log("url",url);
      const res = await axios.post(url, {
            name, //מהטופס 
            phone,//מהטופס 
            option,//מהטופס 
            freeText,//מהטופס 
            screenWidth, //מידע כללי
            deviceType,  //מידע כללי
            source,   //params
            campaign, //params
            landingPageid, //נקבע למעלה 
            clientId, //נקבע למעלה 

            
            acceptsMarketing ,// בעתיד מהטופס 
            acceptedTerms ,// בעתיד מהטופס 
     
});
// console.log("res.data 500" , res.data);
// console.log("res..status 500" , res.status);


      if (res.status === 200 || res.status === 201) {
        // console.log("res?.data!!" ,res?.data);
        setIsFormSent(true);
        setErrorMessage('');
        // setName('');
        // setPhone('');
        // setOption('');
      } else {
   
        //  if (res.status === 400 || res.status === 401)
        setErrorMessage('אירעה שגיאה בשליחה');
              console.log("res.data.response", res.data.response);
      }
    } catch (err) {

      console.log("err status", err.status);
      
      if (err.status === 500 || err.status === 501 || err.status === 502){
        console.log("בעיות בקאנד");
      setisConnectionProblem(true);
      }

      else if (err.status === 400 || err.status === 401){
      console.error("err status",err.status );
      const errorMessage = err.response?.data?.message
      if (errorMessage){ setErrorMessage(errorMessage);}
      else {
        setErrorMessage('אירעה שגיאה, נסה שנית');
      }
    } else if (!err.status ) {
      // שגיאה שלא כוללת תגובת שרת (למשל שרת לא זמין)
      setErrorMessage('לא מצליח להתחבר לשרת, בדוק את חיבור האינטרנט');
      setisConnectionProblem(true);
    } else {
      setErrorMessage('אירעה שגיאה לא צפויה, נסה שנית');
    }
  }
};

  useEffect(() => {
    if (errorMessage) {
      setShake(true);
      const timeout = setTimeout(() => setShake(false), 500); // מסיר את האנימציה כדי לאפשר אותה שוב
      return () => clearTimeout(timeout);
    }
  }, [errorMessage]);

  useEffect(() => {
if (freeText === "" || freeText === null || freeText === undefined) {
  return;
}
if  (freeText.length > textAreaMaxlength || freeText.length === textAreaMaxlength  )
  {setErrorMessage(` מקסימום ${textAreaMaxlength} תווים`)}
else{setErrorMessage("")}
  }, [freeText]);

  return (
 
  
 

    <div className="forms-stuff"  dir="rtl">

      <label htmlFor="name">שם מלא
      <input
        placeholder="השם שלך"
        id='name'
        onChange={e => setName(e.target.value)}
        value={name}
        type="text"
      />

      </label>

<label htmlFor="phoneNumber">טלפון
  <input
    placeholder="05.."
    id="phoneNumber"
    onChange={e => {
      const onlyNums = e.target.value.replace(/\D/g, ''); // מסנן תווים לא מספריים
      setPhone(onlyNums);
    }}
    value={phone}
    type="tel"
    inputMode="numeric"
    pattern="[0-9]*"
  />
</label>

            <label htmlFor="name">מה אתם מחפשים?
      <select
       className="custom-select"
        onChange={e => setOption(e.target.value)}
        value={option}
      >
        <option value="">בחרו אפשרות</option>
      {Array.isArray(offerData)  && offerData.length > 0   &&
        offerData.map(offer => (
          <option key={offer.dealId} value={offer.headline}>
            {offer.headline}
          </option>
        ))}
 <option key="x" value="אחר">
         *. אחר
          </option>
      </select>
      </label>

{/* 
const [freeText, setFreeText] = useState('') */}
<label htmlFor="freeText">טקסט חופשי
  <textarea
    placeholder="אפשר לדלג – אבל אם בא לך לשתף, אנחנו כאן :)"
    id="freeText"
    onChange={e => setFreeText(e.target.value)}
    value={freeText}
    type="text"
    maxLength={textAreaMaxlength}
  />
</label>


 <div className='buttonAndError'>
      {errorMessage && (
        <p
          className={`errorMessage color-orange ${shake ? 'shake' : ''}`}
          dir="rtl"
          style={{marginLeft:"20px"}}
        >
          {errorMessage}
        </p>
      )}

 
      <a className="mailbtn" href="mailto:alonkerklies@gmail.com?subject=פנייה מעמוד הנחיתה&body=שלום, רציתי לשאול לגבי..."> מעדיף מייל</a>

      <button
        className="btn-type-b btn-true-size mt-s-10"
        onClick={makeClick}
        style={{ marginRight: 'auto' }}
      > 
 
        <p>שלח</p>
        <img src='./for-all-app/arrow1.svg'alt={`arrow`} style={{height:"12px"}} className=' '/>
      </button>
    </div>
 
    </div>
 

 
 );
}

export default ContactForm;
